import { createActions, createState, createReducer } from 'reduxsauce-crud'

const d = { deep: true }

export const ReEnrollFromDisenrollmentsRedux = createActions(
  {
    reEnrollFromDisenrollmentsRequest: ['studentId', 'data'],
    reEnrollFromDisenrollmentsSuccess: ['data'],
    reEnrollFromDisenrollmentsFailure: ['errors'],
  },
  {
    prefix: 'REENROLL_FROM_DISENROLLMENTS',
    defaultActions: {
    },
  },
)

const { Types, Creators } = ReEnrollFromDisenrollmentsRedux
export const ReEnrollFromDisenrollmentsTypes = Types
export default Creators

export const INITIAL_STATE = createState({
  sending: {
    fetching: false,
    error: null,
  },
}, {
})

/* ------------- Reducers ------------- */

const reEnrollFromDisenrollmentsRequest = state => state.merge({
  sending: {
    fetching: true,
    error: null,
  },
  new_reenroll_from_disenrollments: {
    error: '',
    success: false,
  },
}, d)

const reEnrollFromDisenrollmentsSuccess = (state, { data }) => state.merge({
  sending: {
    fetching: false,
    error: null,
  },
  new_reenroll_from_disenrollments: {
    error: '',
    success: true,
  },
  ...data,
}, d)

const reEnrollFromDisenrollmentsFailure = (state, { errors }) => state.merge({
  sending: {
    fetching: false,
    error: errors,
  },
  new_reenroll_from_disenrollments: {
    success: false,
    error: errors[0],
  },
}, d)


export const reducer = createReducer(
  INITIAL_STATE, {
    [Types.reEnrollFromDisenrollmentsRequest]: reEnrollFromDisenrollmentsRequest,
    [Types.reEnrollFromDisenrollmentsSuccess]: reEnrollFromDisenrollmentsSuccess,
    [Types.reEnrollFromDisenrollmentsFailure]: reEnrollFromDisenrollmentsFailure,
  },
  {
    defaultActions: {
    },
    Types,
  },
)



// WEBPACK FOOTER //
// ./src/Data/Redux/ReEnrollFromDisenrollmentsRedux.js